(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

	var currentParams = location.href.split('?')[1];
	var params = currentParams.split('&');
	var configData = JSON.parse(sessionStorage.getItem('configData'));

	if (configData == null || configData == undefined || configData == 'undefined') {
		var configData = {};
		configData.model = params[0].split('=')[1];
		configData.color = params[1].split('=')[1];
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
	}

	configData.configStep = 'floor-plan';
	sessionStorage.setItem('configData', JSON.stringify(configData));
	localStorage.setItem('configData', JSON.stringify(configData));
	var $containers = $('.selectionContainer');

	if ($containers.length <= 1) {
		setTimeout(function () {
			$containers[0].click();
		}, 350);
	}

	$('.pl-explore-modal-trigger').click(function (e) {
		e.preventDefault();
		$('.pl-explore-modal .slick-light').slick('unslick');
		$('.pl-explore-modal').show();
	});

	$('.pl-selection-grid .selectionContainer').click(function (e) {
		e.preventDefault();
		var floorplanId = $(this).attr('data-id'),
		    newParams;
		if (!currentParams.includes(floorplanId)) {
			newParams = currentParams + '&floorplan=' + floorplanId;
		} else {
			newParams = currentParams;
		}

		if (jQuery(this).children('.pl-gbImg').children('.pl-check-container').children('input').prop('checked')) {
			jQuery(this).children('.pl-gbImg').children('.pl-check-container').children('input').prop('checked', false);
			//jQuery(this).removeClass('selected-card');
		} else {
			jQuery(this).children('.pl-gbImg').children('.pl-check-container').children('input').prop('checked', true);
		}

		var configData = JSON.parse(sessionStorage.getItem('configData'));
		configData.floorplan = floorplanId;
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
		jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tc/decor/' + buildURLParams());
		jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
	});

	// jQuery('.card-floorplan').on('click', function(e){
	// 	e.preventDefault();

	// 	$(this).addClass('selected-card');

	// 	if(jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked')){
	// 		jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
	// 		jQuery(this).removeClass('selected-card');
	// 	}else{
	// 		jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', true);
	// 	}

	// 	if(jQuery(this).siblings('.selected-card')){
	// 		jQuery(this).siblings('.selected-card').children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
	// 		jQuery(this).siblings('.selected-card').removeClass('selected-card');
	// 	}

	// 	var currentParams = location.href.split('?')[1];
	// 	var selectedFloorplan = jQuery(this).attr('data-id');
	// 	if(!currentParams.includes(selectedFloorplan)){
	// 		var newParams = currentParams + '&floorplan=' + selectedFloorplan;
	// 	}else{
	// 		newParams = currentParams;
	// 	}

	// 	var configData = JSON.parse(sessionStorage.getItem('configData'));

	// 	configData.floorplan = selectedFloorplan;

	// 	sessionStorage.setItem('configData', JSON.stringify(configData));

	// 	jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/decor/' + buildURLParams());

	// 	jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
	// })

	// jQuery('.pl-zoom-modal-trigger').click(function(e){
	// 	imgToShow = $(this).children('img').attr('src');
	// 	$('.pl-zoom-modal .pl-modal-content img').attr('src', imgToShow);
	// })
});

},{}]},{},[1]);
